import React, { useEffect, useState } from "react";
import Navbar from "../component/Navbar/NavbarCommon";
import Footer from "../component/Footer/FooterCommon";
import ArrowButton from "../component/Common/ArrowButton";
import { api } from "../api";
import { ResponseTypes } from "../api/types";
import { API_URL, ASSETS_URL, POCKET_BASE_URL } from "../utils/config";
import { toast } from "react-toastify";
import { useCountryStore } from "../store/useCountryStore";

const EmployeeBirthdayCards: React.FC = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [birthdayList, setBirthdayList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const { country } = useCountryStore();

  // Navbar scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (Math.abs(currentScrollY - lastScrollY) < 5) return;
      setIsNavbarVisible(currentScrollY < lastScrollY || currentScrollY < 50);
      setLastScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // Fetch employees having birthday this month
  useEffect(() => {
    fetchAllEmployees();
  }, [country]);
  function sortByBirthday(arr: any): any {
    return arr.sort((a, b) => {
      const parse = (birthday: string) => {
        const [monthStr, dayStr] = birthday.split(" ");
        const day = parseInt(dayStr.replace(/\D/g, ""), 10); // remove suffix like 'th', 'st'
        const month = new Date(`${monthStr} 1, 2000`).getMonth(); // year doesn't matter
        return new Date(2000, month, day).getTime();
      };
      return parse(a.birthDay) - parse(b.birthDay);
    });
  }

  const fetchAllEmployees = async () => {
    try {
      setLoading(true);
      // Pass country parameter to get country-specific data
      const countryParam = country?.name || "India";
      const { data, error } = await api.get<ResponseTypes>(
        `${API_URL.birthMonth}?country=${countryParam}`,
      );
      if (error) {
        toast.error(error.message);
        return;
      }
      if (data?.data) {
        console.log(data?.data);

        setBirthdayList(sortByBirthday(data?.data));
      }
    } catch (err) {
      toast.error("Failed to fetch birthdays");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Navbar */}
      <Navbar isVisible={isNavbarVisible} />

      {/* Header */}
      <div className="mt-[140px] px-4 sm:px-6 lg:px-10">
        <ArrowButton />
        <div className="mb-6 sm:mb-8 md:mb-10 text-center sm:text-left my-7">
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-black mb-2 sm:mb-3 leading-tight">
            <span className="text-navgreen">Employee</span> Birthdays This Month
          </h1>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 font-medium leading-relaxed max-w-4xl">
            Celebrate and acknowledge our employees who have birthdays this
            month.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 mt-4 px-4 sm:px-6 lg:px-10 pb-20">
        {loading ? (
          <p className="text-center text-gray-500 text-lg mt-20">
            Loading birthdays...
          </p>
        ) : birthdayList.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 pb-2">
            {birthdayList.map((emp: any) => (
              <div
                key={emp._id}
                className="bg-white rounded-xl shadow-lg p-4 flex flex-col items-center text-center hover:shadow-2xl transition-shadow duration-300"
              >
                <img
                  src={
                    emp?.profilePic
                      ? `${ASSETS_URL}${emp.profilePic}`
                      : emp?.userId
                        ? `${POCKET_BASE_URL}${emp?.userId}`
                        : "assets/user-4.svg"
                  }
                  alt={emp.name}
                  className="w-20 h-20 rounded-full mb-3 object-cover border"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = "assets/user-4.svg";
                  }}
                />
                <h2 className="font-semibold text-lg text-gray-800">
                  {emp.name}
                </h2>
                <p className="text-gray-500 text-sm mb-2 line-clamp-2">
                  {emp.designation || emp.department || "Employee"}
                </p>
                <span className="text-green-600 font-medium">
                  {emp.birthDay || "—"}
                </span>
                {/* <p className="text-xs text-gray-400 mt-1">
                  Age: {emp.age ?? "-"} | {emp.country || "India"}
                </p> */}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-500 text-lg mt-20">
            No birthdays this month 🎈
          </p>
        )}
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default EmployeeBirthdayCards;
